import PrimaryTable from "../../components/Table/PrimaryTable"
import { useDispatch, useSelector } from "react-redux";
import { setLoan, setLoanLoading } from "../../features/loan/loanSlice";
import { Box } from "@mui/material";
import useLoanColumns from "../../components/TableHeader/LoanColumns";
import { useGetLoanMutation } from "../../features/loan/loanApi";

const LoanCase = ({leadData}) => {

    const dispatch = useDispatch();
    
    const { loan, totalRowCount, isloanLoading } = useSelector((state) => state.loan);

    const columns = useLoanColumns();
    

    const [getLoanCase] = useGetLoanMutation();

    const fetchData = async ({ pagination, sorting, columnFilters, globalFilter }) => {
            dispatch(setLoanLoading(true));
            try {
              const res = await getLoanCase({
                pageIndex: pagination.pageIndex,
                pageSize: pagination.pageSize,
                sorting,
                columnFilters,
                globalFilter,
                data: {
                  customerID: leadData?.customerID,leadID: leadData?.leadID,DB: leadData?.TAG
                },
              }).unwrap();
        
              dispatch(setLoan({ data: res?.data, totalRowCount: res?.data?.totalRowCount })); // Adjust if backend sends total count separately
            } catch (error) {
            } finally {
              dispatch(setLoanLoading(false));
            }
    };

    return (
        <>
     
               <PrimaryTable
                                                             columns={columns}
                                                             data={loan}
                                                             isLoading={isloanLoading}
                                                             totalRowCount={totalRowCount}
                                                             fetchData={fetchData}
                />
        </>
    )

}


export default LoanCase
